import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';

import AvailabilityStatus from '@bibliocommons/availability-status';
import { availabilityShape, bibShape } from '@bibliocommons/bc-prop-types';
import Capsule from '@bibliocommons/capsule';
import { Dropdown, DropdownMenuItem } from '@bibliocommons/base-dropdown';
import { Button } from '@bibliocommons/base-buttons';
import { ChevronDown, ChevronRight } from '@bibliocommons/base-icons';

import BibLink from 'app/components/shared/BibLink';
import BibManifestationInfo from '../BibManifestationInfo';

import './FormatChooserCapsule.scss';

export function FormatChooserCapsule(props) {
  function renderEdition(edition) {
    const { handleEditionClick } = props;

    return (
      <DropdownMenuItem key={edition.get('id')}>
        <BibLink
          dataKey="edition-link"
          handleClick={() => handleEditionClick?.(edition)}
          metadataId={edition.getIn(['briefInfo', 'metadataId'])}
        >
          <BibManifestationInfo
            bib={edition}
            availability={edition.get('availability')}
            showAvailability
            showPublicationDate
            showEdition
          />
        </BibLink>
      </DropdownMenuItem>
    );
  }

  function renderAdditionalInfo() {
    const { isActive, editions } = props;
    if (isActive)
      return editions && editions.size > 0 ? (
        <Dropdown
          renderTrigger={handleToggle => (
            <Button handleClick={handleToggle} type="button" dataKey="expand-editions" className="expand-editions">
              <FormattedMessage tagName="span" id="additional_edition_count" values={{ count: editions.size }} />
              <ChevronDown />
            </Button>
          )}
          dataKey="editions-dropdown"
        >
          {props.editions.map(renderEdition)}
        </Dropdown>
      ) : null;
    return (
      <AvailabilityStatus
        aria-hidden
        rollUpStatus={props.availability.get('statusType')}
        status={props.availability.get('localisedStatus')}
        availabilityLocationType={props.availability.get('availabilityLocationType')}
      />
    );
  }

  const { isActive, availability, bib, className, displayChevron, formatsCount, ...rest } = props;
  const statusType = availability.get('statusType').toLowerCase();

  const contentClassNames = cn('format-chooser-capsule-content', {
    [statusType]: isActive
  });

  const capsuleProps = {
    active: isActive,
    className: cn('cp-format-chooser-capsule', className),
    contentClassName: contentClassNames,
    dataKey: 'format-chooser-capsule',
    renderSecondaryInfo: renderAdditionalInfo,
    ...rest
  };

  return (
    <Capsule {...capsuleProps}>
      <BibManifestationInfo
        bib={bib}
        availability={availability}
        showPublicationDate={isActive}
        formatsCount={formatsCount}
      />
      {displayChevron && <ChevronRight />}
    </Capsule>
  );
}

FormatChooserCapsule.defaultProps = {
  displayChevron: true
};

FormatChooserCapsule.propTypes = {
  availability: availabilityShape.isRequired,
  bib: bibShape.isRequired,
  className: PropTypes.string,
  displayChevron: PropTypes.bool,
  editions: ImmutablePropTypes.listOf(bibShape),
  formatsCount: PropTypes.number,
  handleClick: PropTypes.func,
  handleEditionClick: PropTypes.func,
  href: PropTypes.string,
  isActive: PropTypes.bool
};

export default FormatChooserCapsule;
